import { useCallback } from "react";
import { useWorkoutProfilesContext } from "@/hooks/useWorkoutProfilesContext";
import { FieldsChangeType } from "@WahooFitness/redesignr";
import { WSMWorkoutProfile } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";
import { WorkoutProfileType } from "@WahooFitness/cloud-client-types";

const containsChanges = (profile: WorkoutProfileType, update: Partial<WorkoutProfileType>) => {
  return Object.keys(update).some(
    (key) => update[key as keyof typeof update] !== profile[key as keyof typeof profile]
  );
};

const useEditWorkoutProfile = (profile?: WSMWorkoutProfile) => {
  const { updateProfile, updateProfileWithObject } = useWorkoutProfilesContext();

  const handleNameChange = useCallback(
    (newValue: string) => {
      if (profile?.external_id) {
        updateProfile(profile.external_id, "name", newValue);
      }
    },
    [updateProfile, profile?.external_id]
  );

  const handleFieldsChange: FieldsChangeType = useCallback(
    (update) => {
      if (profile?.external_id && containsChanges(profile, update)) {
        updateProfileWithObject(profile.external_id, update);
      }
    },
    [profile, updateProfileWithObject]
  );

  return {
    handleNameChange,
    handleFieldsChange,
  };
};

export default useEditWorkoutProfile;
